import {createSvgIcon} from '../create-svg-icon';

export const TrendingUpIcon = createSvgIcon(
  <path d="m16 6 2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z" />
, 'TrendingUpOutlined');
